import { useTranslation } from "react-i18next";
import { translate as tr } from "../../i18n";
import React from "react";
import { Link } from "react-router-dom";
import "../../assets/scss/footer.scss";

const HelpIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="10" cy="10" r="7" />
    <path d="M7.9 7.6a2.35 2.35 0 1 1 3.3 2.15c-.95.45-1.45.98-1.45 2" />
    <circle cx="10" cy="14.2" r="0.7" fill="currentColor" stroke="none" />
  </svg>
);

const DocumentIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M6 2.5h5l3 3V15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4.5a2 2 0 0 1 2-2Z" />
    <path d="M11 2.5V6h3" />
    <path d="M7 9.5h6M7 12.5h6" />
  </svg>
);

const ShieldIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M10 2.5 4.5 5v4.4c0 3.3 2.23 6.28 5.5 7.1 3.27-.82 5.5-3.8 5.5-7.1V5L10 2.5Z" />
    <path d="m7.7 10 1.6 1.6 3.1-3.3" />
  </svg>
);

const BuildingIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 17V5.5A1.5 1.5 0 0 1 5.5 4H11v13" />
    <path d="M11 7h3.5A1.5 1.5 0 0 1 16 8.5V17" />
    <path d="M7 7.5h1M7 10.5h1M7 13.5h1M13 10.5h1M13 13.5h1" />
  </svg>
);

const MinutezillaWhiteLogo = () => (
  <svg viewBox="0 0 1000 600" aria-label="Minutezilla" role="img">
    <path
      fill="#FFFFFF"
      d="M662.06,194.99c-18.34,8.2-36.58,16.35-54.82,24.51c-1.93-1.79-2.85-3.93-4.01-5.88c-17.06-28.42-41.09-48.57-71.94-60.58c-13.17-5.13-26.84-7.96-40.94-9.06c-17.68-1.38-34.94,0.7-51.85,5.71c-19.25,5.71-36.47,15.18-51.69,28.34c-11.43,9.88-21.24,21.11-29,34.08c-3.87,6.47-7.61,13.03-10.14,20.18c-0.2,0.57-0.58,1.14-0.13,2.16c7.29,1.69,14.8,3.43,22.29,5.17c1.45-1.29,1.99-2.93,2.72-4.39c12.49-25.02,30.98-44.09,56.26-56.25c10.53-5.07,21.72-8.25,33.34-9.78c1.93-0.25,3.86-1.08,6.2-0.21c0.17,3.43,0.43,6.94,0.49,10.46c0.09,5.34,0.16,10.69,0.02,16.03c-0.15,5.67,3.85,8.93,8.52,9.52c2.62,0.33,5.22,0.21,7.75-0.74c3.79-1.41,5.76-3.99,5.8-8.06c0.08-7.96,0.06-15.93,0.1-23.89c0.01-1.03-0.19-2.1,0.36-3.29c2.27-0.82,4.65,0.03,6.93,0.35c21.94,3.05,41.31,11.9,58.28,26.1c11.98,10.02,21.31,22.15,28.92,35.69c1.18,2.09,2.35,4.19,3.75,6.68c36.27-15.97,71.86-33.16,108.01-49.07c0.63,1.04-0.19,1.29-0.57,1.66c-16.58,16.47-33.95,32.1-51.3,47.75c-16.18,14.59-32.72,28.77-49.07,43.17c-9.9,8.73-19.71,17.56-29.59,26.31c-13.96,12.36-27.97,24.66-41.93,37.03c-12.23,10.84-24.42,21.73-36.64,32.58c-2.51,2.22-5.14,4.31-7.6,6.58c-1.28,1.18-2.41,1.25-3.96,0.56c-9.58-4.24-19.2-8.38-28.79-12.58c-14.97-6.55-29.93-13.11-44.89-19.7c-13.52-5.96-27.01-11.96-40.52-17.93c-17.33-7.67-34.68-15.32-52-23.01c-7.66-3.4-15.25-6.94-22.95-10.25c-2.11-0.91-2.69-2.18-2.69-4.33c0.04-30.92-0.06-61.83,0.07-92.75c0.04-10.28,1.08-20.47,4.11-30.4c3.5-11.49,8.97-21.87,16.66-31.08c10.95-13.13,24.7-22.22,40.8-27.73c7.95-2.72,16.19-4.32,24.62-4.63c28.39-1.07,56.79-0.36,85.18-0.46c36.68-0.13,73.36-0.05,110.04-0.03c13.84,0.01,27.35,1.96,40.22,7.32c16.07,6.69,29.24,17.05,39.37,31.22c8.64,12.09,13.76,25.56,15.75,40.26c0.21,1.55,0.42,3.11,0.58,4.67C662.23,193.49,662.12,194.02,662.06,194.99z M562.73,245.28c-0.05-6.16-3.21-10.29-8.56-11.97c-3.5-1.11-6.6-0.12-9.63,1.5c-5.27,2.82-10.12,6.32-15.15,9.52c-11.13,7.08-22.19,14.27-33.23,21.48c-1.88,1.23-3.58,1.63-5.84,0.95c-4.29-1.29-8.73-1.23-13,0.14c-2,0.64-3.57,0.42-5.32-0.6c-13.41-7.75-26.85-15.46-40.3-23.14c-2.45-1.4-4.83-2.94-7.61-3.68c-6.17-1.64-12.01,1.39-13.76,7.18c-1.63,5.39,0.29,10.04,5.76,13.62c4.21,2.75,8.47,5.41,12.75,8.04c10.61,6.52,21.23,13.04,31.89,19.48c1.9,1.15,3.16,2.55,3.79,4.71c0.71,2.42,1.91,4.63,3.68,6.51c5.47,5.81,12.11,8.36,20.08,7.32c8.53-1.11,15.34-7.27,17.14-15.69c0.36-1.7,1.23-2.71,2.64-3.63c16.36-10.56,32.68-21.17,49.02-31.76C560.91,252.78,562.9,249.34,562.73,245.28z M336.2,283.15c0,3.46-0.02,6.92,0.01,10.37c0.03,3.22,0.62,3.85,3.91,3.82c5.86-0.05,11.71-0.51,17.58-0.39c2.6,0.05,3-0.42,3-3.23c-0.01-10.17,0.61-20.3,1.77-30.4c0.26-2.28-0.08-2.85-2.28-3.37c-5.71-1.34-11.47-2.46-17.29-3.19c-3.53-0.44-4.97,0.86-5.41,4.46C336.6,268.5,336.21,275.81,336.2,283.15z"
    />
    <path
      fill="#FFFFFF"
      d="M285.62,333.45c63.52,34.03,126.1,69.42,189.08,103.73c2.04-0.8,2.84-2.51,4.09-3.75c9.66-9.61,18.56-19.93,27.78-29.95c12.35-13.4,24.31-27.15,36.72-40.5c8.34-8.97,16.54-18.08,24.75-27.18c12.78-14.14,25.49-28.35,38.27-42.48c7.38-8.16,14.87-16.21,22.26-24.36c8.86-9.78,17.64-19.63,26.52-29.4c1.94-2.13,3.85-4.34,6.39-6.21c0.85,1.32,0.58,2.6,0.58,3.78c0.02,14.78,0,29.56-0.01,44.33c-0.01,35.42,0.03,70.85-0.06,106.27c-0.03,10.73-1.43,21.31-4.97,31.5c-7.88,22.71-22.39,39.71-43.77,50.84c-8.16,4.25-16.73,7.26-25.78,8.76c-5.67,0.94-11.39,1.67-17.17,1.67c-26.72,0-53.45,0.01-80.17,0.03c-25.47,0.02-50.93,0.08-76.4,0.09c-12.68,0-25.37,0.13-38.04-0.2c-20.78-0.53-39.79-6.53-56.29-19.5c-17.18-13.51-27.52-31.27-32.15-52.48c-1.34-6.15-1.95-12.41-2.01-18.71c-0.03-3.04-0.04-6.08-0.06-9.12c-0.11-13.72-0.22-27.45-0.33-41.17C284.81,337.59,284.82,335.71,285.62,333.45z"
    />
  </svg>
);

export default function Footer() {
  useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="dash-footer">

      {/* ── Brand ── */}
      <div className="dash-footer-brand">
        <div className="dash-footer-logo">
          <MinutezillaWhiteLogo />
        </div>
        <div>
          <div className="dash-footer-name">Minutezilla</div>
          <div className="dash-footer-tagline">{tr("Time tracking, simplified.")}</div>
        </div>
      </div>

      {/* ── Nav links ── */}
      <nav className="dash-footer-nav">
        <Link to="/help"><HelpIcon /><span>{tr("Help")}</span></Link>
        <span className="dash-footer-sep" />
        <Link to="/agb"><DocumentIcon /><span>{tr("AGB")}</span></Link>
        <span className="dash-footer-sep" />
        <Link to="/datenschutz"><ShieldIcon /><span>{tr("Datenschutz")}</span></Link>
        <span className="dash-footer-sep" />
        <Link to="/impressum"><BuildingIcon /><span>{tr("Impressum")}</span></Link>
      </nav>

      {/* ── Copyright + version ── */}
      <div className="dash-footer-right">
        <span className="dash-footer-copy">
          &copy; {year} <strong>Minutezilla</strong>{tr(". All rights reserved.")} </span>
        <span className="dash-footer-version">v1.0</span>
      </div>

    </footer>
  );
}
